import { defineComponent as r, createBlock as t, openBlock as a, unref as c, mergeProps as p, withCtx as u, createElementVNode as m } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconCurrencyPound",
  __name: "IconCurrencyPound",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (i, e) => (a(), t(c(s), p(o, { "view-box": "0 0 24 24" }), {
      default: u(() => e[0] || (e[0] = [
        m("path", { d: "M8.25 8.5A3.75 3.75 0 0 1 12 4.75c1.588 0 2.919.953 3.294 2.002a.75.75 0 1 0 1.412-.504C16.081 4.497 14.103 3.25 12 3.25a5.25 5.25 0 0 0-3.674 9H6a.75.75 0 0 0 0 1.5h3.34c-.88 1.808-2.01 3.342-3.56 4.452a1.265 1.265 0 0 0-.53 1.026V19.5a1.25 1.25 0 0 0 1.25 1.25H18a.75.75 0 0 0 0-1.5H6.887c1.88-1.425 3.16-3.363 4.107-5.5h3.565a.75.75 0 0 0 0-1.5H12A3.75 3.75 0 0 1 8.25 8.5" }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  f as default
};
